
import Vue from 'vue';
import i18n from '@/translations/i18n';

export default Vue.extend({
  name: 'YearlyLiveStockTable',
  props: {
    groups: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    months: { type: Array, default: () => [{ id: 0, name: '' }] },
  },
  data: () => ({
    headers: [
      { text: i18n.t('yearlylivestock.month'), sortable: false, value: 'maand' },
      { text: i18n.t('yearlylivestock.amount'), sortable: false, value: 'horseCount', colspan: 3 },
    ],
  }),
  methods: {
    getOccupation(group, month) {
      return this.groups[group].months[month] ? this.groups[group].months[month].occupation : 'N.V.T.';
    },
  },
});
